import { motion } from "framer-motion";
import QRCode from "qrcode";
import { useEffect } from "react";
import DownloadMotionLink from "@/components/DownloadMotionLink";
import { getDownloadUrl } from "@/utils/download";
import config from "@/config";

export default function DownloadCTA() {
  const downloadUrl = getDownloadUrl();

  useEffect(() => {
    QRCode.toCanvas(document.getElementById('apk-qr-code'), downloadUrl, function (error) {
      if (error) console.error(error)
      console.log('success!');
    })
  }, [downloadUrl]);

  return (
    <section className="px-4 py-6 text-center" id="download">
      <motion.div
        className="mb-3 text-2xl tracking-widest text-primary-400"
        initial={{ opacity: 0, scale: 0.5 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ type: "spring", stiffness: 200, damping: 15 }}
      >
        ★★★★★
      </motion.div>
      <motion.p
        className="mb-5 text-sm text-foreground-400"
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2, duration: 0.4 }}
      >
        評価 4.9 · 日本で200万ダウンロード突破
      </motion.p>

      <DownloadMotionLink
        downloadType="button"
        className="mx-auto flex w-full max-w-sm items-center justify-center gap-2 rounded-2xl bg-primary-500 py-4 text-sm font-bold text-white shadow-none cursor-pointer"
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.95 }}
        animate={{
          boxShadow: [
            "0 0 0 0 oklch(var(--primary-500) / 0)",
            "0 0 0 10px oklch(var(--primary-500) / 0.12)",
            "0 0 0 0 oklch(var(--primary-500) / 0)",
          ],
        }}
        transition={{
          boxShadow: {
            repeat: Infinity,
            duration: 2.2,
            ease: "easeInOut",
          },
        }}
      >
        <motion.span
          className="text-lg"
          animate={{ scale: [1, 1.2, 1] }}
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
        >
          🔞
        </motion.span>
        <span>アプリをダウンロードして無料で楽しむ</span>
      </DownloadMotionLink>

      {/* QR Code for desktop users */}
      <motion.div
        className="mx-auto mt-6 flex max-w-sm items-center gap-5 rounded-2xl bg-background-100/60 p-5 backdrop-blur-sm"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        <motion.div
          className="relative shrink-0 overflow-hidden rounded-xl bg-white p-2"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
        >
          {/* <img
            src={`https://api.qrserver.com/v1/create-qr-code/?size=130x130&data=${encodeURIComponent(downloadUrl)}&bgcolor=ffffff&color=2d0a14&margin=10`}
            alt="QRコードでアプリをダウンロード"
            className="h-[110px] w-[110px] md:h-[130px] md:w-[130px]"
            width={130}
            height={130}
          /> */}
          <canvas className="h-[110px] w-[110px] md:h-[130px] md:w-[130px]"
            id="apk-qr-code"
            width={130}
            height={130} />
          <div className="absolute -bottom-0.5 -right-0.5 rounded-tl-lg bg-primary-500 px-2 py-0.5 text-[10px] font-bold text-white">
            SCAN
          </div>
        </motion.div>
        <div className="text-left">
          <p className="text-sm font-bold text-foreground-100">
            📱 QRコードからダウンロード
          </p>
          <p className="mt-1.5 text-xs leading-relaxed text-foreground-500">
            スマホのカメラでQRコードをスキャンするだけ。
            <br />
            アプリを無料でインストールできます。
          </p>
          <div className="mt-2.5 flex items-center gap-2">
            <span className="flex items-center gap-1 rounded-full bg-background-200/60 px-2 py-0.5 text-[10px] font-medium text-foreground-400">
              <i className="ri-android-fill text-sm" />
              Android
            </span>
          </div>
        </div>
      </motion.div>

      {/* QR Code for mobile - compact single line hint */}
      <motion.p
        className="mt-4 text-xs text-foreground-600 md:hidden"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.4 }}
      >
        PCからのアクセスはQRコードで簡単ダウンロード ↗
      </motion.p>

      <div className="mt-4 flex items-center justify-center gap-4 text-xs text-foreground-700">
        <a href="/terms" className="transition-colors hover:text-foreground-500">
          利用規約
        </a>
        <span className="text-foreground-800">|</span>
        <a href="/privacy" className="transition-colors hover:text-foreground-500">
          プライバシーポリシー
        </a>
        <span className="text-foreground-800">|</span>
        <a href="/commercial-law" className="transition-colors hover:text-foreground-500">
          特定商取引法に基づく表記
        </a>
      </div>

      <p className="mt-4 text-[10px] text-foreground-800">
        © 2024 {config.siteTitle}. All Rights Reserved. 18歳未満の閲覧禁止
      </p>
    </section>
  );
}